export default "__VITE_ASSET__Bvk4vkyS__"